import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input } from 'antd';
import {getData} from '../../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { Drawer,Popconfirm } from 'antd';
 import axios from 'axios';

const { RangePicker } = DatePicker;

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}

const dateFormat = 'YYYY/MM/DD';

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			page:1,
			employee_list : [],
			timeline_details : [],
			marketing_followup_details : [],
			enquiries_details : [],
			checkedBoxes: [],
			fees_setting : [],
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			fees_view: false,
			timeline: false,
			checkAll: false,
			checked: false,
			import_visible: false,
			import_loading: false,
			csv_file:null,
			msg: '',
			sms_text:'',
			email_subject:'',
			email_body:'',
			selection_count:0,
			sms_visible:false,
			email_visible:false,
			currentDate:'',
			source:'',
			academic_year:'',
			date:'',
			keyword:'',
			from_date: '',
			to_date: '',
		}
		this.onChangechecked = this.onChangechecked.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		
		this.inputChange = this.inputChange.bind(this);	
		this.submit_search = this.submit_search.bind(this);	
		this.change_source = this.change_source.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.onChangedate = this.onChangedate.bind(this);	
		this.onChangefrom_ = this.onChangefrom_.bind(this);
		this.onChangeto_ = this.onChangeto_.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id'] });
		
		}
		this.checkData();	
		
	}
	
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var is_complete = 1;
			
			var app = {
			  user_id : user_id,
			  school_id:school_id,
			  is_complete:is_complete,
			  from_date : this.state.from_date,
			  to_date : this.state.to_date,
			  keyword:this.state.keyword,
			}
			getData('credzoTaskManager/task_manager_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							employee_list: result['data'],
						});
					}else{
						this.setState({
							employee_list: [],
						});
					}
				}
			});
	}
  }
  
 
  	onChangefrom_(time, timeString) {
	  this.setState({
		  from_date: timeString,
		});
	}
	
	onChangeto_(time, timeString) {
	  this.setState({
		  to_date: timeString,
		});
	}
  
	submit_search(){		
		this.setState({
            filter_visible: false,
        })
		setTimeout(() => {
			this.checkData();
		}, 500);
	}
	
	change_source(event){
         this.setState({source: event});
    }
	
	change_year(event){
         this.setState({academic_year: event});
    }
	 	 
	 onChangedate(date, dateString) {
	  this.setState({ date: dateString });
	}
  
  onChangechecked(checkedValues) {
	  this.setState({ checked_id: this.state.checked_id.concat(checkedValues) });
	}	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
 
  
  onChange = e => {
    console.log('checked = ', e.target.checked);
    this.setState({
      checked: e.target.checked,
    });
  };
  
  toggleChecked = () => {
    this.setState({ checked: !this.state.checked });
  };
   
  showFilter = () =>  {
		this.setState({
			filter_visible: true,
		});		
	}
	
	closeFilter = () =>  {
		this.setState({
			filter_visible: false,
		});		
	} 
	
	toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
  handleCheckbox = (e, s) => {
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length});
  }
  
  inputChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	}
	
	deletedata = (id) => {
		if(this.state.checkedBoxes.length>0){
			var app = {user_id : this.state.user_id,id:this.state.checkedBoxes,school_id:this.state.school_id}
			getData('credzoTaskManager/task_delete',app).then((result) => {
				let responseJson = result;
				if(responseJson){
					if(result['status'] == 200){
						this.setState({
							marketing_delete: result['data'],
						});
						this.checkData();
						message.config({ top: 150});
						message.success('Selected Task deleted',2);
					}else{
						this.setState({
							marketing_delete: [],
						});
					}
				}
			});
		}
		else{
			message.config({ top: 150});
			message.error('Please select Task',2);
		}
	}; 
	
	

	render() {
	
	var lenght = this.state.employee_list.length; 
	
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
           
			
			<div class="col col-md-12  ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m8 l8 pt-15 pb-15 ">
						<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Task Manager - Completed</span></h5>
                     </div>
                     <div class="col s12 m4 l4 right-align-md pt-15 pb-15">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li> 
						   <li class="breadcrumb-item"><a href="/">Task Manager</a>
                           </li>
                           <li class="breadcrumb-item active">Completed
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
			
			
			<Drawer
				title="Filter"
				placement="left"
				width={400}
				closable={false}
				onClose={this.closeFilter}
				visible={this.state.filter_visible}
			>
			<div class="filter">
				<div class="col m4 s12 mb-20 no-padd">
						
					<div class="col m2 s6  mb-20 no-padd">
						<label>From Date</label>
						<DatePicker onChange={this.onChangefrom_} />
					</div>
					<div class="col m2 s6  mb-20 no-padd">
						<label>To Date</label>
						<DatePicker onChange={this.onChangeto_} />
					</div>
					<div class="col m4 s12 mb-20 no-padd">
						<label>Search Keyword</label>
						<input type="text" class="form-control" name="keyword"  onChange={this.handleSizeChange}/>
					</div>
					<div class="col m4 s12 mb-20 no-padd">						
						<button type="button" class="primary-btn right ml-1" onClick={this.submit_search}>
							Submit
						</button>
						<button onClick={this.closeFilter} type="button" class="cancel-btn right ml-1">
							Cancel
						</button>
					</div>
				</div>
				</div>
			</Drawer>
			
			<Modal
					title="Mark Out Time"
					visible={this.state.followup}
					className="followup-model "
					onOk={this.handleOkfollowup}
					onCancel={this.handleCancelfollowup}
				>
														
							
				<div class="col m12 s12  mt-10">
					<label className="d-block">Remark</label>
					<TextArea rows={4} style={{'width' : '100%'}} />
				</div>
								
				  
				<div class="col col-md-12 s12 center mt-10">
					<Button className="snd-btn" onClick={this.handleOkfollowup} loading={this.state.loading}>Submit</Button>
				</div>	
				
				
			</Modal>
	
			
            <div class="col col-md-12  ex-padd enquiry bg-off">
               <div class="container">
                  <section class="invoice-list-wrapper  section">
                     <div class="responsive-table iq-card bg-shadow-none">
					
						<ul class="nav nav-tabs" role="tablist">
						<li class="nav-item">
							<Link to={`${process.env.PUBLIC_URL}/task-manager/ongoing` } class="nav-link ">Ongoing</Link>
						</li>
						<li class="nav-item">
							<Link to={`${process.env.PUBLIC_URL}/task-manager/completed`} class="nav-link active">Completed</Link>
						</li>
						
						
					</ul>
					
					 
                        <div class="dataTables_wrapper no-footer mh-500 ">
                           <div class="top display-flex flow-root ">
							  <div class="actions action-btns display-block align-items-center col col-md-12  right hidden-xs no-padd">
								
								<button onClick={this.showFilter} class="action_btn mt-5 hidden-xs"><i class="ri-filter-line"></i> Filter</button>
							
								<Popconfirm
								title="Are you sure delete?"
								onConfirm={this.deletedata}
								okText="Yes"
								cancelText="No"
							  >
								<button className="action_btn delete_btn mt-5 right"><i class="ri-delete-bin-7-line"></i> Delete</button>
							  </Popconfirm>
							  
								
                              </div>
							  
							 
                           </div>
                           
                           <div class="clear"></div>
						 
						<div class="table-responsive res mt-10">
						   <table class="cust_table data-list-view">
      <thead>
        <tr>
          <th>
			{(() => {
				if (this.state.checked==true) {
					return (
						<>
						<Checkbox  
							onClick={this.toggleUnChecked.bind(this)}
							checked="checked"
						>
						</Checkbox>
						</>
					)
				}
				else{
					return (
						<>
						<Checkbox  
							onClick={this.toggleChecked.bind(this)}
							checked=""
						>
						</Checkbox>
						</>
					)
				}
			})()}
			</th>
          <th>Emplyee</th>
          <th>Title</th>
          <th>Date & Time</th>
          <th>Last Comment By</th>
        </tr>
      </thead>

      <tbody>
		
		{this.state.employee_list.map((list) => (
        <tr>
								<td data-label="Select" class="table-check">
								 <Checkbox  
									name="checked_id[]"
									value={list.id}
									checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
									onChange={(e) => this.handleCheckbox(e, list.id)}
								 >
								 </Checkbox>
								  </td>
								
								<td data-label="Emplyee">
								{list.employee_name.map((emp) => (
								<p class="mb-0">{emp.name}</p>
								))}
								</td>
								<td data-label="Title">{list.title}</td>
								<td data-label="Date & Time">{list.date_time}</td>
								<td data-label="Last Comment By">{list.last_comment}</td>
					
		</tr>								
		))}
		{(() => {  
											if (lenght =='0') {
											return (
											<td id="error" class="center" colspan="6">No Data Found</td>
													)
												}
											})()}
      </tbody>
    </table>
	</div>
	
	
                        </div>
						
						
						
                     </div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
